import WidgetFooter from './Footer';

export default WidgetFooter;
